(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('NomenclatureController', NomenclatureController);

    NomenclatureController.$inject = ['NomenclatureService', '$state', '$stateParams','AlertService','$localStorage','$translate'];

    function NomenclatureController(NomenclatureService, $state, $stateParams,AlertService,$localStorage,$translate) {
        var vm = this;

        vm.status = 'loading';
        vm.coExhibitorId = $stateParams.id;
        vm.selected = {};
        vm.nomenclature = [
            {
                key: 'c1',
                items: [
                    'c1i1',
                    'c1i2',
                    'c1i3',
                    'c1i4',
                ]
            },
            {
                key: 'c2',
                items: [
                    'c2i1',
                    'c2i2',
                    'c2i3',
                    'c2i4',
                    'c2i5',
                    'c2i6',
                    'c2i7',
                ]
            },
            {
                key: 'c3',
                items: [
                    'c3i1',
                    'c3i2',
                    'c3i3',
                    'c3i4',
                    'c3i5',
                    'c3i6',
                    'c3i7',
                    'c3i8',
                ]
            },
            {
                key: 'c4',
                items: [
                    'c4i1',
                    'c4i2',
                    'c4i3',
                ]
            },
            {
                key: 'c5',
                items: [
                    'c5i1',
                    'c5i2',
                ]
            },
            {
                key: 'c6',
                items: [
                    'c6i1',
                    'c6i2',
                    'c6i3',
                    'c6i4',
                    'c6i5',
                    'c6i6',
                    'c6i7',
                ]
            },
            {
                key: 'c7',
                items: [
                    'c7i1',
                    'c7i2',
                    'c7i3',
                    'c7i4',
                ],
            },
            {
                key: 'c8',
                items: [
                    'c8i1',
                    'c8i2',
                    'c8i3',
                    'c8i4',
                ]
            },
            {
                key: 'c9',
            },
            {
                key: 'c10',
            },
        ];

        vm.submit = submit;

        init();

        function init() {
            vm.status = 'loading';
            NomenclatureService.loadNomenclature(vm.coExhibitorId).then(function (response) {
                angular.forEach(response.data.nomenclature, function (key) {
                    vm.selected[key] = true;
                });
                vm.status = 'loaded';

                if ($localStorage.showCoExhibitorLogoFeeAddedToCart !== undefined && $localStorage.showCoExhibitorLogoFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.coExhibitorLogoFeeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showCoExhibitorLogoFeeAddedToCart;
                }
                if ($localStorage.showLogoFeeAddedToCart !== undefined && $localStorage.showLogoFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.logoFeeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showLogoFeeAddedToCart;
                }
                if ($localStorage.showCoExhibitorFeeAddedToCart !== undefined && $localStorage.showCoExhibitorFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.coExhibitorFeeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showCoExhibitorFeeAddedToCart;
                }
                if ($localStorage.showFeeAddedToCart !== undefined && $localStorage.showFeeAddedToCart == true) {
                    var successMsg = $translate.instant('nomenclature.feeAddedToCart');
                    AlertService.success(successMsg, {}, 'bottom right');
                    delete $localStorage.showFeeAddedToCart;
                }

            }, function () {
                vm.status = 'notfound';
            });
        }

        function submit() {
            var keys = [];

            angular.forEach(Object.keys(vm.selected), function (key) {
                if (vm.selected[key] === true) {
                    keys.push(key);
                }
            });

            NomenclatureService.postNomenclature(vm.coExhibitorId, keys).then(function () {
                $state.go('home', {}, {reload: true, notify: true});
            }, function () {
                alert('Error!');
            });
        }
    }
})();
